import type { TDownloadFileOptions } from './downloadFile.types.ts';

const URL_RELEASE_DELAY = 1000;

const clickDownloadLink = (href: string, filename: string): void => {
  const anchor = document.createElement('a');

  anchor.href = href;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const downloadFile = (options: TDownloadFileOptions): void => {
  if ('url' in options) {
    clickDownloadLink(options.url, options.filename);

    return;
  }

  const blob = new Blob([options.content], { type: options.type });
  const objectUrl = URL.createObjectURL(blob);

  clickDownloadLink(objectUrl, options.filename);
  setTimeout(() => URL.revokeObjectURL(objectUrl), URL_RELEASE_DELAY);
};
